<app-header class="full-width"></app-header>
<main id="content" class="js-content" role="main">
  <app-breadcrumbs [breadcrumbs]="[{ url: '.', name: 'Home' }, { name: 'Contact' } ]"></app-breadcrumbs>
  <div class="grid-row">
    <div class="column-two-thirds">
      <h1 class="heading-xlarge">Contact</h1>
      <p>If you have a question about the MTC, you can: </p>
      <ul>
          <li>visit our <a class="govuk-link" href="https://help.multiplicationtablescheckservice.education.gov.uk">
              MTC help centre
              </a> 
          </li>
          <li>use our <a class="govuk-link" href="https://askonline.education.gov.uk/chatbot/davina?regional=true">
              virtual assistant
              </a>
          </li>
          <li><a class="govuk-link" href="https://help.multiplicationtablescheckservice.education.gov.uk/hc/en-gb/requests/new?ticket_form_id=">
              contact us
              </a> directly 
          </li>
      </ul>
      <br />
      <p>If you are still unable to find an answer to your question, you can contact the national curriculum assessments helpline on 0300 303 3013, selecting the option for MTC. </p>
    </div>

    <div class="column-one-third add-title-margin">
      <br />
      <aside role="complementary" class="support-column">
        <h3 class="heading-medium">Related</h3>
        <nav role="navigation">
          <ul class="list">
            <li>
              <a href="/">Home</a>
            </li>
          </ul>
        </nav>
      </aside>
    </div>
  </div>
</main>
<app-footer></app-footer>
